import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/models/data/user.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { EmailChangeFormComponent } from '../email-change-form/email-change-form.component';
import { PasswordChangeFormComponent } from '../../shared/password-change-form/password-change-form.component';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
  imports: [
    CommonModule,
    EmailChangeFormComponent,
    PasswordChangeFormComponent,
  ],
})
export class UserProfileComponent implements OnInit {
  authenticatedUser: User = {} as User;
  selectedOption: string = 'change-email';

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.authService.user.subscribe((user) => {
      this.authenticatedUser = user;
    });
  }

  passwordChanged(event: any): void { }
}
